export * from './lib/brightai.module';
export * from './lib/routes/brightai.routes';
